import { Component } from '@angular/core';
import { AbstractControl, UntypedFormArray } from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { EMPTY } from 'rxjs';

import { BaseFormComponent, FormManagerService } from '@sim/form';

import { Capability, CapabilityMeta, Role, RoleMeta } from '@sim/role/models/role';
import { RoleApiService } from '@sim/role/services/role-api.service';

@Component({
  selector: 'app-role-manager',
  styleUrls: ['./role-manager.component.scss'],
  templateUrl: './role-manager.component.html',
})
export class RoleManagerComponent extends BaseFormComponent<Role> {

  readonly capabilities$ = this.roleApi.indexCapabilities();

  constructor(
    protected readonly translate: TranslateService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly formManager: FormManagerService,
    protected readonly spinner: NgxSpinnerService,
    private readonly roleApi: RoleApiService,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      undefined,
      RoleMeta,
      (id) => roleApi.get(id as string),
      '/roles',
      router,
    );
  }

  addConcrete(role: Role) {
    return this.roleApi.post(role);
  }

  removeConcrete(role: Role) {
    if (role.id) {
      return this.roleApi.remove(role.id);
    }
    return EMPTY;
  }

  editConcrete(role: Role) {
    return this.roleApi.put(role);
  }

  resetFormConcrete() {
    return EMPTY;
  }

  toggleCapability(data: MatCheckboxChange, capability: Capability) {
    if (!this.entityControls || !this.entityControls.capabilities) {
      throw new Error('Cannot manage capabilities without a control');
    }

    if (data.checked) {
      const capabilityControl = this.formManager.makeForm(CapabilityMeta, { name: capability.name, id: capability.id });
      (this.entityControls.capabilities as UntypedFormArray).push(capabilityControl);
    } else {
      const findFactory = (c: AbstractControl) => c.value.id === capability.id;
      const capabilityIndexControl = (this.entityControls.capabilities as UntypedFormArray).controls.findIndex(findFactory);
      (this.entityControls.capabilities as UntypedFormArray).removeAt(capabilityIndexControl);
    }
  }
}
